import { MDBBtn, MDBDataTable, MDBIcon } from "mdbreact"
import React from 'react'
import Select from 'react-select'
import { Card, CardBody, Col, Container, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from "reactstrap"
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import Breadcrumbs from '../../components/Common/Breadcrumb'
import _valid from "../../validations"

const columns = [
    {
        label: 'Código',
        field: 'codigo',
        sort: 'asc'
    },
    {
        label: 'Nombre',
        field: 'nombre',
        sort: 'asc'
    },
    {
        label: 'Marca',
        field: 'marca',
        sort: 'asc'
    },
    {
        label: 'Serie',
        field: 'serie',
        sort: 'asc'
    },
    {
        label: 'Descripción',
        field: 'descripcion',
        sort: 'asc'
    },
    {
        //label: 'Cantidad',
        //field: 'cantidad',
        label: 'Cantidad disponible',
        field: 'cantidadNoAsignadaColaborador',
        sort: 'asc'
    },
    {
        label: 'Costo',
        field: 'costo',
        sort: 'asc'
    },
    {
        label: 'Fecha de Creación',
        field: 'fecha_creacion_str',
        sort: 'asc'
    },
    {
        label: "Acciones",
        field: "handle",
        width: 100
    }
];

export default class ArticuloNoAsignado extends React.Component {

    constructor(props) {
        super(props)

        this.apiRest = new ApiRest(props);

        this.state = {
            tabla: { columns: columns, rows: [] },
            modalAbierto: false,
            modalAsignarArticulo: false,
            mostrarSpinner: true,
            articuloSeleccionado: { nombre: null },
            departamentoAreaSelectValue: null,
            areaTrabajoSelectValue: null,
            articuloSelectValue: null,
            cantidadNoAsignada: 0,
            articuloAsignar: {},
            colaboradores: [],
            departamentosAreas: [],
            errors: {
                colaboradorSelectValue: { esValido: false },
                areaTrabajoSelectValue: { esValido: false },
                departamentoAreaSelectValue: { esValido: false },
                cantidad: { esValido: true }
            }
        }
    }

    componentDidMount() {
        this.cargarListado();
    }

    cargarListado = () => {
        this.setState({ mostrarSpinner: true });
        if (this.apiRest.getLS('idEmpresa')) {
            this.apiRest.getArticuloEmpresa('/getArticuloNoAsignado/').then(respuesta => {
                if (respuesta.exitoso) {
                    this.setState({ mostrarSpinner: false, tabla: this.agregarAccionesRegistro(respuesta.data) });
                }
            });
        } else {
            if (this.apiRest.getRol()) {
                this.apiRest.get('/articuloNoAsignado').then(respuesta => {
                    if (respuesta.exitoso) {
                        this.setState({ mostrarSpinner: false, tabla: this.agregarAccionesRegistro(respuesta.data) });
                    }
                });
            }
        }
    }

    agregarAccionesRegistro = rows => {
        rows.forEach(registro => registro.handle = this.botonesListado(registro));
        return { columns, rows: rows };
    };

    botonesListado = registro => [
        <MDBBtn className="waves-effect" size="sm" color="primary" title="Editar" onClick={() => this.mostrarModalAsignarArticulo(registro)}>
            <MDBIcon icon="far fa-user" />
        </MDBBtn>
    ];

    asignarArticulo = () => {
        let articuloAsignar = this.state.articuloAsignar;
        articuloAsignar.crearTarjetaResponsabilidad = true;
        if ( this.verificarCantidad(articuloAsignar)) {
           this.verificarColaborador(articuloAsignar);
        }
    }

    verificarCantidad = (datos) => {
        let contador = 0;
        if(_valid(datos.cantidad)){
            if(datos.cantidad <= this.state.cantidadNoAsignada) {
                contador++;
            } else {
                toastr.error('La cantidad no puede ser mayor a la cantidad disponible');
            }
        }else{
            toastr.error('Debe ingresar una cantidad');
        }

        if(_valid(datos.idColaborador)){
            contador++;
        }else{
            toastr.error('Debe seleccionar un colaborador');
        }

        if(_valid(datos.idDepartamentoArea)){
            contador++;
        }else{
            toastr.error('Debe seleccionar un departamento');
        }

        if(_valid(datos.idAreaTrabajo)){
           contador++;
        }else{
            toastr.error('Debe seleccionar un área de trabajo');
        }

        if(contador === 4){
            return true;
        }else{
            return false;
        }
    }

    verificarColaborador = (articuloAsignar) => {
        
        this.apiRest.get('/autheticarColaborador/' + articuloAsignar.idColaborador).then(resultado => {
            if (resultado.exitoso) {
                let estado = resultado.data
                if (estado == 'Aceptado') {
                    this.apiRest.post('/tarjetaResponsabilidadAsignarArticulo', articuloAsignar).then(resultado => {
                        if (resultado.exitoso) {
                            toastr.success('Datos almacenados exitosamente!');
                            this.ocultarModalAsignarArticulo();
                            this.cargarListado();
                        } else {
                            toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                        }
                    });
                } else {
                    toastr.error('Datos incompletos del colaborador');
                }
            }
        });
    }

    mostrarModalAsignarArticulo = articulo => {
        this.setState({ modalAsignarArticulo: true, articuloAsignar: {}, departamentoAreaSelectValue: null, areaTrabajoSelectValue: null });

        this.obtenerColaboradores();
        this.setArticulo(articulo);
    }

    ocultarModalAsignarArticulo = () => {
        this.setState({ modalAsignarArticulo: false });
    }

    setArticulo = articulo => {
        this.setState(estadoAnterior => ({
            articuloAsignar: { ...estadoAnterior.articuloAsignar, ['idArticulo']: articulo.id },
            articuloSeleccionado: articulo
        }));

        this.setState(estadoAnterior => ({
            articuloAsignar: { ...estadoAnterior.articuloAsignar, ['cantidad']: articulo.cantidadNoAsignadaColaborador},
            cantidadNoAsignada: articulo.cantidadNoAsignadaColaborador
        }));

        /*this.apiRest.get('/articuloCantidadNoAsignada/' + articulo.id).then(resultado => {
            if (resultado.exitoso) {
                console.log(resultado.data.cantidadNoAsignada );
                this.setState(estadoAnterior => ({
                    articuloAsignar: { ...estadoAnterior.articuloAsignar, ['cantidad']: resultado.data.cantidadNoAsignada },
                    cantidadNoAsignada: resultado.data.cantidadNoAsignada
                }));
            } else {
                toastr.error('Vaya! Ha ocurrido un error, al obtener la cantidad no asignada, intenta nuevamente en unos segundos.');
            }
        });*/
    }

    setColaborador = colaborador => {
        this.setState(estadoAnterior => ({
            articuloAsignar: { ...estadoAnterior.articuloAsignar, ['idColaborador']: colaborador.id },
            colaboradorSelectValue: colaborador
        }));
        this.setState(estadoAnterior => ({
            articuloAsignar: { ...estadoAnterior.articuloAsignar, ['idDepartamentoArea']: colaborador.id_departamento }
        }));
        this.obtenerDepartamentosAreas();
    }

    setDepartamentoArea = departamentoArea => {
        this.setState(estadoAnterior => ({
            articuloAsignar: { ...estadoAnterior.articuloAsignar, ['idDepartamentoArea']: departamentoArea.id },
            departamentoAreaSelectValue: departamentoArea
        }));
    }

    setAreaTrabajo = areaTrabajo => {
        this.setState(estadoAnterior => ({
            articuloAsignar: { ...estadoAnterior.articuloAsignar, ['idAreaTrabajo']: areaTrabajo.id },
            areaTrabajoSelectValue: areaTrabajo
        }));
    }

    setCantidad = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            articuloAsignar: { ...estadoAnterior.articuloAsignar, ['cantidad']: value },
        }));
    }

    obtenerColaboradores = () => {
        if (this.apiRest.getRol()) {
            this.apiRest.get('/colaborador').then(respuesta => {
                if (respuesta.exitoso) {
                    this.setState({ colaboradores: respuesta.data });
                } else {
                    this.setState({ colaboradores: [] });
                }
            });
        } else {
            if (this.apiRest.getLS('idEmpresa')) {
                this.apiRest.getColaborador('/getColaborador/').then(respuesta => {
                    if (respuesta.exitoso) {
                        this.setState({ colaboradores: respuesta.data });
                    } else {
                        this.setState({ colaboradores: [] });
                    }
                });
            }
        }
    }

    obtenerDepartamentosAreas() {
        this.apiRest.get('/colaboradorDepartamentoAreaAsociados').then(resultado => {
            if (resultado.exitoso) {
                this.setState({ departamentosAreas: resultado.data });
                this.siHayDepartamentoArea(resultado.data);
                this.obtenerAreasTrabajo();
            }
        });
    }

    siHayDepartamentoArea = (departamentosAreas) => {
        let departamentoArea = [];
        if (_valid(this.state.articuloAsignar.idDepartamentoArea)) {
            this.apiRest.getRol() ?
                departamentoArea = departamentosAreas.find(departamentoArea => departamentoArea.id === this.state.articuloAsignar.idDepartamentoArea)
                :
                departamentoArea = departamentosAreas.find(departamentoArea => departamentoArea.value === this.state.articuloAsignar.idDepartamentoArea)
            this.setState({ departamentoAreaSelectValue: departamentoArea });
        }
    }

    obtenerAreasTrabajo = () => {
        this.apiRest.get('/getAreaTrabajo').then(respuesta => {
            if (respuesta.exitoso) {
                this.setState({ areasTrabajo: respuesta.data });
            } else {
                this.setState({ areasTrabajo: [] });
            }
        });
    }

    render() {
        const {
            errors
        } = this.state;
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Activos" breadcrumbItem="Articulos No Asignados" />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    {
                                        _valid(this.apiRest.getEmpresaNombre()) ?
                                            <Label htmlFor="#" className="form-label">
                                                {'Empresa: ' + this.apiRest.getEmpresaNombre()}
                                            </Label> : ''
                                    }
                                    <CardBody>
                                        {
                                            this.apiRest.getRol() ?
                                                <MDBBtn className="waves-effect" color="warning" onClick={() => this.cargarListado()}>
                                                    <MDBIcon icon="fa fa-info-circle" />{' '}
                                                    Actualizar Listado
                                                </MDBBtn>
                                                : ''
                                        }
                                        <p />
                                        {
                                            this.state.mostrarSpinner &&
                                            <Row>
                                                <Col style={{ display: "flex", justifyContent: "center" }}>
                                                    <Spinner className="m-1" color="primary" />
                                                </Col>
                                            </Row>
                                        }
                                        <div className="table-responsive">
                                            <MDBDataTable hover searchLabel="Buscar.." paginationLabel={["Anterior", "Siguiente"]} noRecordsFoundLabel="No hay datos." infoLabel={["Mostrando desde ", "hasta", " | Entradas totales: ", ""]} entriesLabel="Mostrando entradas" data={this.state.tabla} />
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>

                {/* MODAL */}
                <Modal isOpen={this.state.modalAsignarArticulo} size="lg">
                    <ModalHeader>
                        Asignar Articulo
                        <h5 className="font-size-16 mb-1">{this.state.articuloSeleccionado.nombre}</h5>
                    </ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col lg={12}>
                                <div className="mb-3 mb-4">
                                    <Label htmlFor="name" className="form-label">
                                        Colaborador
                                    </Label>
                                    <Select
                                        name="colaboradorSelectValue"
                                        options={this.state.colaboradores}
                                        onChange={this.setColaborador}>
                                    </Select>
                                </div>
                            </Col>
                            <Col lg={6}>
                                <div className="mb-3 mb-4">
                                    <Label htmlFor="solicitar_a" className="form-label">
                                        Departamento / Area
                                    </Label>
                                    <Select
                                        name="departamentoAreaSelectValue"
                                        options={this.state.departamentosAreas}
                                        value={this.state.departamentoAreaSelectValue}
                                        onChange={this.setDepartamentoArea}
                                        validate={{ required: { value: true } }}
                                    />
                                </div>
                            </Col>
                            <Col lg={6}>
                                <div className="mb-3 mb-4">
                                    <Label htmlFor="name" className="form-label">
                                        Area Fisica Trabajo
                                    </Label>
                                    <Select
                                        name="areaTrabajoSelectValue"
                                        value={this.state.areaTrabajoSelectValue}
                                        options={this.state.areasTrabajo}
                                        onChange={this.setAreaTrabajo}
                                        validate={{ required: { value: true } }}
                                    >
                                    </Select>
                                    <div className={this.state.errors.areaTrabajoRequerido ? 'error' : 'hidden'}>Requerido</div>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={6}>
                                <div className="mb-3 mb-4">
                                    <Label htmlFor="cantidad" className="form-label">
                                        Cantidad Disponible Para Asignar: {this.state.cantidadNoAsignada}
                                    </Label>
                                    {/*<Input
                                        name="cantidadNoAsignada"
                                        value={this.state.cantidadNoAsignada}
                                        type="number"
                                        className="form-control"
                                        disabled="disabled"
                                    />*/}
                                </div>
                            </Col>
                            <Col lg={6}>
                                <div className="mb-3 mb-4">
                                    <Label htmlFor="cantidad" className="form-label">
                                        Cantidad para Asignar:
                                    </Label>
                                    <Input
                                        name="cantidad"
                                        value={this.state.articuloAsignar.cantidad}
                                        onChange={this.setCantidad}
                                        min="0"
                                        max={this.state.cantidadNoAsignada}
                                        type="number"
                                        className="form-control"
                                        placeholder="Ingresa la cantidad"
                                    />
                                    <div class="invalid-feedback" style={{ display: errors.cantidad.esValido ? "none" : "block" }}>Requerido</div>
                                </div>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter className="text-center">
                        <MDBBtn className="waves-effect" color="success" onClick={() => this.asignarArticulo()}>
                            <MDBIcon icon="fas fa-user-check" /> {' '}
                            Asignar
                        </MDBBtn>
                        <MDBBtn className="waves-effect" color="warning" onClick={() => this.ocultarModalAsignarArticulo()}>
                            <MDBIcon icon="fas fa-times" /> {' '}
                            Cancelar
                        </MDBBtn>
                    </ModalFooter>
                </Modal>
            </React.Fragment>
        )
    }
}